export const ListMonitoringAI = () => (
  <iframe
    src="https://metabase.hello-syndic.fr/public/dashboard/42d8e86b-08b2-45d2-875b-6ca3649e3970"
    frameBorder="0"
    width="100%"
    scrolling="no"
    style={{ overflowY: 'hidden', height: '2500px' }}
  ></iframe>
)
